module.exports = __webpack_public_path__ + "img/XK.2937ddb0.svg";